// Wrapper component that shows desktop or mobile version based on screen size.
import AcademicCalendarDesktop from './AcademicCalendarDesktop';
import AcademicCalendarMobile from './AcademicCalendarMobile';

export default function AcademicCalendar() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <AcademicCalendarDesktop />
      </div>

      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <AcademicCalendarMobile />
      </div>
    </>
  );
}
